'use strict';
import angular from 'angular';

angular.module('app.ctrls')
    .controller('loginController', ['$scope', '$state', function($scope, $state){

        $scope.ioLogin = function(){
            $state.go('orders');
        };

    }]);